import React from "react";

interface Props {
  message: string | null;
  type?: "success" | "error" | "info" | "warning";
  onClose?: () => void;
  className?: string;
}

const FlashMessage: React.FC<Props> = ({
  message,
  type = "info",
  onClose,
  className,
}) => {
  if (!message) return null;
  const bootstrapType = type === "error" ? "danger" : type;
  return (
    <div
      className={`alert alert-${bootstrapType} d-flex justify-content-between align-items-center py-2 ${
        className || ""
      }`}
    >
      <span>{message}</span>
      {onClose && (
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          style={{ fontSize: "0.6rem" }}
        />
      )}
    </div>
  );
};

export default FlashMessage;
